import { IStorageUser, OnlineStorage } from "@tblabs/storage";
import { Div, PopupMenu, RefBool } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { AuthIcon } from "./AuthIcon";
import { UserSectionWhenLoggedIn } from "./UserSectionWhenLoggedIn";


export class UserSection extends Div
{
    constructor(_storage: OnlineStorage, _router: Router)
    {
        super();

        const isUserAuthorized = new RefBool(false);

        _storage.OnUserChange((u: IStorageUser, isAuthorized: boolean) =>
        {
            isUserAuthorized.value = isAuthorized;

            let extra: { [key: string]: () => void } = {};
            if (_storage.CanUser("ListDatabases"))
            {
                extra = { ["🏛️ All databases"]: () => _router.GoToAllDatabasesPage() }
            }

            const menu = {
                ...extra,
                ["🏢 This database panel"]: () => _router.GoToDatabasePage(_storage.DatabaseDir),
                ["🏠 Exit"]: () => _router.GoToLoginPage(),
                ["🔒 Logout"]: () => _storage.Logout(),
            };

            const openMenuButton = new UserSectionWhenLoggedIn(_storage)
                .VisibleWhen(isUserAuthorized, v => v == true, "flex");

            this.Clear().Append(
                new AuthIcon()
                    .OnClick(() => _router.GoToLoginPage())
                    .InvisibleWhen(isUserAuthorized),

                new PopupMenu(menu, openMenuButton),
            );
        });
    }
}
